module.exports = __webpack_public_path__ + "img/Quick-Release.07235ac6.png";